export default __webpack_public_path__ + "static/media/best-party.46b179e4.png";